// Generated by tools/sounds/render.py: the gain that brings each sound to the same loudness.
// The rendered files carry it already; the live synth applies it so a file and its fallback sound alike.
import type { SoundId } from './catalog';

export const LEVEL: Partial<Record<SoundId, number>> = {
  shush: 1.0017,
  white: 1.0858,
  womb: 0.8938,
  heart: 0.9242,
  hair: 1.0871,
  fan: 1.0346,
  vacuum: 0.9327,
  washer: 1.4134,
  car: 0.7092,
  rain: 1.5302,
  ocean: 1.4020,
  music: 1.1266,
};
